import { render, staticRenderFns } from "./BulkDeleteModal.vue?vue&type=template&id=6f3097f0&scoped=true"
import script from "./BulkDeleteModal.vue?vue&type=script&lang=js"
export * from "./BulkDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./BulkDeleteModal.vue?vue&type=style&index=0&id=6f3097f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3097f0",
  null
  
)

export default component.exports